module.exports = __webpack_public_path__ + "static/media/objects_19.7730ab45.svg";